import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const SNMG = atom({
    key: "SNMG",
    default: 20000,
    // effects_UNSTABLE: [persistAtom],
});

export const TauxBEA = atom({
    key: "TauxBEA",
    default: 0.095,
    // effects_UNSTABLE: [persistAtom],
});

export const DurationCredit = atom({
    key: "DurationCredit",
    default: 48,
    // effects_UNSTABLE: [persistAtom],

});

export const Salary = atom({
    key: "Salary",
    default: 30000,
    effects_UNSTABLE: [persistAtom],
});


export const PremiumClient = atom({
    key: "PremiumClient",
    default: false,
    effects_UNSTABLE: [persistAtom],
});

export const age = atom({
    key: "age",
    default: 18,
    // effects_UNSTABLE: [persistAtom],
});

export const borrowedCapital = atom({
    key: "borrowedCapital",
    default: 0.00,
    // effects_UNSTABLE: [persistAtom],
});

export const CAAT = atom({
    key: "CAAT",
    default: 0.00,
    // effects_UNSTABLE: [persistAtom],
});
export const TALA = atom({
    key: "TALA",
    default: 0.00,
    // effects_UNSTABLE: [persistAtom],
});

export const TMM = atom({
    key: "TMM",
    default: 0.00,
    // effects_UNSTABLE: [persistAtom],
});

export const hamishEldjedia = atom({
    key: "hamishEldjedia",
    default: 0.00,
    // effects_UNSTABLE: [persistAtom],
});

export const modalState = atom({
    key: "modalStatus",
    default: false,
    effects_UNSTABLE: [persistAtom],
});
export const simulatorState = atom({
    key: "simulatorState",
    default: false,
    effects_UNSTABLE: [persistAtom],
});